import { Injectable } from '@angular/core';
import * as _jsonata from 'jsonata';

const jsonata: any = (_jsonata as any).default ?? _jsonata;

@Injectable({ providedIn: 'root' })
export class ExpressionEngineService {
	/** Evaluate a JSONata expression against your data. Example expr: "$sum(array.(time * 1000 + cost))" */
	async evaluate<T = any, R = any>(expr: string, data: T): Promise<R> {
		const compiled = jsonata(expr);
		// You can also pass custom functions via compiled.registerFunction(...)
		return compiled.evaluate(data) as Promise<R>;
	}
}
